import { Organization, Patient, Practitioner } from '@medplum/fhirtypes';
import { createReference, MedplumClient } from '@medplum/core';
import { fetchBot } from './services';
import createFaxFile from '@/pages/FaxingPage/createFaxFile';

export type FaxDirection = 'inbound' | 'outbound';

export async function sendFax(
  medplum: MedplumClient,
  recipient: Organization | undefined | null,
  recipientNumber: string | null,
  files: File[],
  content: string,
  subject: string,
  profile: Practitioner,
  patient?: Patient
) {
  if (!recipient) {
    throw new Error('Recipient is required');
  }

  const faxFile = await createFaxFile({
    content,
    subject,
    recipient: recipient.name,
    recipientNumber,
    profile,
  });

  const attachments = await Promise.all(
    [faxFile, ...files].map(async (file) => {
      return medplum.createAttachment({
        data: file,
        contentType: file.type,
        filename: file.name,
      });
    })
  );

  const payloadAttachments = attachments.map((attachment) => ({
    contentAttachment: attachment,
  }));

  return fetchBot(medplum, 'send-fax', {
    recipients: [createReference(recipient)],
    payloadAttachments,
    recipientNumber: recipientNumber ?? '',
    patient: patient ? createReference(patient) : undefined,
  });
}
